import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Alert,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import logo from "../../images/logoSimple.png";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useUserInfo } from "../../utils/user";
import { useAuth } from "../../utils/auth";

const buildMenuItems = ({ isCoach, stripeCustomerId, handleClose }) => {
  if (isCoach) {
    return [
      { to: "/clients", label: "Clients" },
      { to: "/client-activity", label: "Client Activity" },
      { to: "/messaging", label: "Messages" },
      { to: "/templates", label: "Programs & Templates" },
      { to: "/content-library", label: "Content Library" },
      { to: "/manage-products", label: "Manage Products" },
      { to: "/payouts", label: "Payouts & Transactions" },
      { to: "/coach-profile", label: "Coach Profile" },
      { to: "/workout-import", label: "Workout Import" },
    ].map((item) => ({
      key: item.to,
      element: (
        <MenuItem
          component={Link}
          to={item.to}
          onClick={handleClose}
          key={item.to}
          sx={{ width: "100%", display: "block" }}
        >
          {item.label}
        </MenuItem>
      ),
    }));
  }

  if (stripeCustomerId) {
    return [
      { to: "/workouts", label: "Workouts" },
      { to: "/subscription", label: "Subscription" },
    ].map((item) => ({
      key: item.to,
      element: (
        <MenuItem
          component={Link}
          to={item.to}
          onClick={handleClose}
          key={item.to}
          sx={{ width: "100%", display: "block" }}
        >
          {item.label}
        </MenuItem>
      ),
    }));
  }

  return [
    {
      key: "payment",
      element: (
        <MenuItem
          component={Link}
          to="/payment"
          onClick={handleClose}
          sx={{ width: "100%", display: "block" }}
        >
          Payment
        </MenuItem>
      ),
    },
  ];
};

const Header = () => {
  const { user, signOut } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const { isCoach, stripeCustomerId, loading, isAccountFullySetup } =
    useUserInfo();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoPath = isCoach ? "/clients" : stripeCustomerId ? "/workouts" : "/";
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <img src={logo} alt="Logo" width="30" />
          <Typography
            variant="h6"
            color="inherit"
            sx={{ ml: 1, "text-decoration": "none" }}
            component={Link}
            to={logoPath}
          >
            Trainer App
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {loading ? (
            <IconButton>
              <CircularProgress size={28} sx={{ color: "white" }} />
            </IconButton>
          ) : (
            <>
              {!user ? (
                <Typography
                  sx={{ color: "white", textDecoration: "none" }}
                  component={Link}
                  to="/login"
                >
                  Login
                </Typography>
              ) : (
                <>
                  <IconButton id="basic-button" onClick={handleClick}>
                    <MenuIcon fontSize="large" sx={{ color: "white" }} />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {buildMenuItems({
                      isCoach,
                      isAccountFullySetup,
                      stripeCustomerId,
                      handleClose,
                    }).map((item) => item.element)}
                    <MenuItem
                      onClick={(e) => {
                        handleClose();
                        signOut();
                      }}
                      sx={{ width: "100%", display: "block" }}
                    >
                      {user && (
                        <Typography sx={{ width: "100%" }}>Logout</Typography>
                      )}
                    </MenuItem>
                  </Menu>
                </>
              )}
            </>
          )}
        </Toolbar>
      </AppBar>
      {!loading && user && isCoach && !isAccountFullySetup && (
        <Alert
          severity="warning"
          sx={{
            borderRadius: 0,
            justifyContent: "center",
            "& a": {
              color: "inherit",
              fontWeight: 600,
              textDecoration: "underline",
            },
          }}
        >
          Your account setup is not finished.{" "}
          <Link to="/coaching">Finish onboarding</Link>
        </Alert>
      )}
    </Box>
  );
};

export default Header;
